import { DateTime } from 'luxon';

export const getDaysAgo = (date: DateTime): number => {
  const now = DateTime.now();
  const diffInDays = now.diff(date, ['days']).days;

  // When user local time is earlier than provided date, we don't want to show -X days
  if (diffInDays < 0) {
    return 0;
  }

  return Math.floor(diffInDays);
};
